import React, {useEffect, useRef, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { useAuth } from '../context';
import Loader from '../components/Loader';
import './Login.css';

const Login = () => {
    const [form, setForm] = useState({ email: '', password: '' });
    const googleBtnRef = useRef(null);
    const { login, loginWithGoogle } = useAuth();
    const navigate = useNavigate();
    // const redirectTo = location.state?.from?.pathname || '/account';

    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const onChange = (e) => setForm((f) => ({...f, [e.target.name]: e.target.value}));

    // Initialize Google Sign-In button
    useEffect(() => {
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        if (!(window && window.google)) return;
        if (!clientId) return;
        try {
            window.google.accounts.id.initialize({
                client_id: clientId,
                callback: async (response) => {
                    try {
                        setSubmitting(true);
                        setError('');
                        await loginWithGoogle(response.credential);
                        navigate('/account');
                    } catch (e) {
                        setError(e?.message || 'Google sign-in failed');
                    } finally {
                        setSubmitting(false);
                    }
                },
                auto_select: false,
                ux_mode: 'popup',
            });
            if (googleBtnRef.current) {
                window.google.accounts.id.renderButton(googleBtnRef.current, {
                    theme: 'outline',
                    size: 'large',
                    width: 320,
                });
            }
        } catch (_err) {
            // ignore init failures gracefully
        }
        return () => {
            try { window.google.accounts.id.cancel(); } catch {}
            try { window.google.accounts.id.disableAutoSelect(); } catch {}
        };
    }, [loginWithGoogle, navigate]);


    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError('');
        try {
            const user = await login(form);
            if (user) {
                navigate('/account');
            } else {
                setError('Invalid email or password');
            }
        } catch (err) {
            setError(err?.message || 'Invalid email or password');
        } finally {
            setSubmitting(false);
        }
    };


    return (
        <div className="login-container">
            <h2 className="login-title">Log in</h2>
            {error && <div className="login-error">{error}</div>}
            <form onSubmit={onSubmit} autoComplete="on">
                <div className="form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        name="email"
                        className="form-input"
                        value={form.email}
                        onChange={onChange}
                        required
                        autoComplete="username"
                        autoCapitalize="off"
                        autoCorrect="off"
                        spellCheck={false}
                        placeholder="you@example.com"
                    />
                </div>
                <div className="form-group">
                    <label>Password</label>
                    <input
                        type="password"
                        name="password"
                        className="form-input"
                        value={form.password}
                        onChange={onChange}
                        required
                        autoComplete="current-password"
                        placeholder="••••••••"
                    />
                </div>
                <button type="submit" disabled={submitting} className="btn btn-primary login-submit">
                    {submitting ? <Loader size="small" color="#fff" /> : 'Sign in'}
                </button>
            </form>

            <div className="login-divider">
                <hr />
                <span>or</span>
                <hr />
            </div>

            <div ref={googleBtnRef} className="google-btn-wrapper"></div>

            <div className="login-footer">
                Don’t have an account? <Link to="/signup">Create one</Link>
            </div>
        </div>
    );

};

export default Login;
